<template>
    <div class="">
      <!-- <titleArea :title="this.$t('menus.pa.chief_prosecutor.title1')" /> -->
      <AboutSection
        :image1="require('@/assets/AllSystem/kpk/image1.png')"
        :image2="require('@/assets/AllSystem/kpk/image2.png')"
        :image3="require('@/assets/AllSystem/kpk/image3.png')"
        :section1Title="$t('menus.kpk.about_us.section1.title')"
        :section1="$t('menus.kpk.about_us.section1.content')"
        :section2Title="$t('menus.kpk.about_us.section2.title')"
        :section2Content="$t('menus.kpk.about_us.section2.content')"
        :section3Title="$t('menus.kpk.about_us.section3.title')"
        :section3Content="$t('menus.kpk.about_us.section3.content')" />
    </div>
  </template>
  <script>  
  import AboutSection from '../share/AboutUs.vue'
  // import titleArea from '../../components/share/TitleArea.vue';

  export default {
    data(){
      return{
        
      }
    },
    components: {
      AboutSection,
      // titleArea
    },
  };
  </script>
  
  <style scoped>
  .textBox:first-child{
    border-right:4px solid #F5BD2A;
    padding-right:10px;
  }
  .textBox:nth-child(2){
    border-left:4px solid #F5BD2A;
    padding-left:10px;
  }
  </style>